<template>
  <section>
    <div class="top-header-with-banner" id="section-3">
      <h2>{{ $t("FastTrack.ServiceReservation") }} {{ title }}</h2>
      <div class="content-current">
        <div class="card-header">
          <h4>
            {{ $t("FastTrack.ConfirmInformations") }}
            <span style="color: #08446a; font-weight: 600">{{ title }}</span>
          </h4>
        </div>
        <div class="row content-current">
          <div class="col-md-12 col-xs-12">
            <div class="box box-info">
              <div class="box-header">
                <h3 class="box-title">
                  <i class="fa fa-info-circle fa-fw" style="color: #fcbe2f"></i
                  ><label>{{ $t("FastTrack.Reserveinformation") }}</label>
                </h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.Services") }}: </label>
                    {{ reservedData.serviceName }}
                    <span v-if="reservedData.scheduleDescription"
                      >( {{ reservedData.scheduleDescription }})</span
                    >
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.GuestCount") }}: </label>
                    {{ reservedData.adultCount }} {{ $t("FastTrack.Adult") }}
                    {{ reservedData.childCount }} {{ $t("FastTrack.Child") }}
                    {{ reservedData.infantCount }} {{ $t("FastTrack.Infant") }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.TotalReserved") }}: </label>
                    {{ reservedData.guestCount }} {{ $t("FastTrack.Person") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.EntryDate") }}: </label>
                    {{ reservedData.toDate | persianDate("YYYY/MM/DD") }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>{{ $t("FastTrack.TimePlan") }}: </label>
                    {{ reservedData.scheduleTime }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label> {{ $t("Price") }}: </label>
                    {{ reservedData.totalPrice | numFormat | rial }}
                  </div>
                </div>
                <div v-if="reservedData.addOnOptionList.length > 0">
                  <hr />
                  <div class="box-header">
                    <h3 class="box-title">
                      <i class="icon-dot-3" style="color: #e04f67"></i
                      ><label>{{ $t("FastTrack.OtherServices") }} </label>
                    </h3>
                  </div>
                  <template v-for="addon in reservedData.addOnOptionList">
                    <div class="row" v-if="addon.selectedCount > 0">
                      <div class="col-md-4 col-sm-4">
                        <label> {{ $t("Name") }}: </label>
                        {{ addon.name }}
                      </div>

                      <div class="col-md-4 col-sm-4">
                        <label>{{ $t("Count") }}: </label>
                        {{ addon.selectedCount }}
                      </div>
                      <div class="col-md-4 col-sm-4">
                        <label> {{ $t("Price") }} : </label>
                        {{
                          (addon.itemPrice * addon.selectedCount) | numFormat
                        }}
                        {{ $t("Rial") }}
                      </div>
                    </div>
                  </template>
                  <hr />
                  <div class="row">
                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>

                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>
                    <div class="col-md-4 col-sm-4">
                      <label> {{ $t("FastTrack.TotalPrice") }} : </label>
                      {{ reservedData.totalAmount | numFormat }}
                      {{ $t("Rial") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box box-success content-current">
          <div class="box-header">
            <h3 class="box-title">
              <i class="fa fa-user fa-fw" style="color: #fcbe2f"></i
              ><label>{{ $t("FastTrack.CustomerInformation") }}</label>
            </h3>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label> {{ $t("Name") }}: </label>
                <span> {{ customerInfo.firstName }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label> {{ $t("LName") }}: </label>
                <span> {{ customerInfo.lastName }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <label>{{ $t("Sex") }}</label>
              <span v-if="customerInfo.gender === 1"> :{{ $t("Male") }} </span>
              <span v-else>: {{ $t("Female") }} </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>{{ $t("Email") }}: </label>
                <span> {{ customerInfo.email }}</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>{{ $t("MobileNumber") }}: </label>
                <span> {{ customerInfo.mobileNumber }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="form-group"
                v-if="customerInfo.selectedNationalId == 1"
              >
                <label>{{ $t("NationalCode") }}: </label>
                <span> {{ customerInfo.nationalCode }}</span>
              </div>
              <div
                class="form-group"
                v-if="customerInfo.selectedNationalId == 2"
              >
                <label> {{ $t("Passport") }}: </label>
                <span> {{ customerInfo.nationalCode }}</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="providerId === 2">
            <div class="col-md-4 col-xs-12">
              <div class="form-group">
                <label> {{ $t("FastTrack.MobileNumber") }}: </label>
                <span> {{ customerInfo.flightNumber }}</span>
              </div>
            </div>
            <div class="col-md-8 col-xs-12">
              <div class="form-group">
                <label><span> </span> {{ $t("Description") }} :</label>
                <span> {{ customerInfo.customerRequest }}</span>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-12 col-xs-12">
              <div class="form-group">
                <label><span> </span> {{ $t("Description") }} :</label>
                <span> {{ customerInfo.customerRequest }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="box box-success content-current"
          v-if="providerId === 2 && guestCount > 1"
        >
          <div class="box-header">
            <h3 class="box-title">
              <i class="icon-users-1" style="color: #2a69b1"></i
              ><label> {{ $t("FastTrack.Companions") }}</label>
            </h3>
          </div>
          <template>
            <div v-for="(guest, i) in guestDetails.adultCount" class="row">
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.AdultName") }}
                    {{ i + 2 }} :</label
                  >
                  <span> {{ guest.firstName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.AdultLastName") }}
                     {{ i + 2 }} :</label
                  >
                  <span> {{ guest.lastName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.AdultPassword") }}
                     {{ i + 2 }} :</label
                  >
                  <span> {{ guest.nationalCode }}</span>
                </div>
              </div>
            </div>
            <div v-for="(guest, i) in guestDetails.childCount" class="row">
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.ChildsName") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.firstName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.ChildsLastName") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.lastName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.ChildsPassport") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.nationalCode }}</span>
                </div>
              </div>
            </div>
            <div v-for="(guest, i) in guestDetails.infantCount" class="row">
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.Infant") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.firstName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span>  {{ $t("FastTrack.InfantsName") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.lastName }}</span>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <label class="special-labels"
                    ><span class="validation-color">*</span> {{ $t("FastTrack.InfantsPassport") }}
                    {{ i + 1 }} :</label
                  >
                  <span> {{ guest.nationalCode }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>

        <hr />

        <div>
          <div class="row">
            <div style="font-size: 16px; margin: 10px 20px">
              <input v-model="ruleChecked" type="checkbox" />
              &ensp;
              <label
                >{{ $t("FastTrack.All") }}
                <a
                  href="#role-dialog"
                  id="role_link"
                  style="cursor: pointer !important"
                  class="role"
                  ><span
                    style="cursor: pointer !important; color: rgb(0 117 255)"
                    >{{ $t("FastTrack.TermsAndConditions") }}</span
                  >
                </a>
                {{ $t("FastTrack.ReadAndAcceptIts") }}.</label
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group" style="font-size: 16px">
                {{ $t("FastTrack.PayablePrice") }} :{{ CalcPaidAmount | numFormat | rial }}
              </div>
            </div>

            <div
              style="font-size: 16px; margin: 10px 20px"
              v-if="customerValueAmount > 0"
            >
              <input v-model="valueAmountChecked" type="checkbox" />
              {{ $t("FastTrack.ApplyRialCredit") }} ({{
                GetCustomerValueAmount | numFormat | rial
              }})
            </div>
          </div>
          <div class="row" v-if="showBankPayment">
            <div class="col-md-12 col-xs-12">
              <div class="form-inline" style="margin: 20px 0px 20px">
                <div v-for="item in paymentTypeItems" :key="item.key">
                  <label class="form-check-label special-labels pointer-bank">
                    <input
                      type="radio"
                      class="form-check-input radio-btn"
                      v-model="selectedPaymentType"
                      :value="item.key"
                    />

                    <span class="radio-title"
                      >{{ item.value }}
                      <!-- <span v-if="item.key === 2"
                      >({{ CalcPaidAmount | numFormat | rial }})</span
                    > -->
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="selectedPaymentType == 1 && showBankPayment">
            <div class="col-md-6">
                <div v-for="(item, index) in ipgList" :key="item.id">
                  <label v-if="item.bankId == 2" class="form-check-label pointer-bank">
                    <input
                      type="radio"
                      class="form-check-input radio-btn"
                      v-model="selectedBank"
                      :value="item.bank.id"
                    />
                    <img
                      v-if="item.bank.logo"
                      :src="'data:image/jpeg;base64,' + item.bank.logo"
                      class="card bg-white img-size"
                    />
                    <span class="radio-title">{{ item.bank.title }} </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-align">
            <button
              type="submit"
              class="btn-profile"
              @click.prevent="book()"
              v-if="ruleChecked && activeButton"
            >
              {{ $t("FastTrack.FinalAcceptAndPay") }} 
            </button>
            <button
              type="submit"
              class="btn-profile"
              style="background-color: #b0c7b9"
              v-if="!ruleChecked && activeButton"
            >
               {{ $t("FastTrack.FinalAcceptAndPay") }} 
            </button>
            <button
              type="submit"
              class="btn-profile"
              style="background-color: #b0c7b9"
              v-if="!activeButton"
            >
              <span v-show="!showBankPayment">
                 {{ $t("FastTrack.FinalAcceptAndPay") }} <i class="icon-left"></i
              ></span>
              <span v-show="showBankPayment"
                >{{ $t("FastTrack.InProgress") }}  ... <i class="fa fa-spinner fa-pulse"></i
              ></span>
            </button>
            <button
              v-if="activeButton"
              type="submit"
              style="background-color: #00c3e1"
              class="btn-profile"
              @click.prevent="editCustomerData()"
            >
              {{ $t("FastTrack.EditInformation") }} 
            </button>
            <button
              v-if="!activeButton"
              type="submit"
              style="background-color: #00c3e1"
              class="btn-profile"
            >
               {{ $t("FastTrack.EditInformation") }} 
            </button>
          </div>

          <TourismRule :rules="reservedData.rules" />
        </div>
      </div>
    </div>
    <div v-if="isLoading">
      <PdkBankLoading />
    </div>
    <!-- <loadingBar v-if="showLoadingBar" /> -->
  </section>
</template>
<script>
import moment from "moment";
import store from "../../views/tourism/store/index";
import TourismRule from "./TourismRuleModal";
import uri from "../../../public/publicUries";
import PdkBankLoading from "../../components/loading/PdkBankLoading.vue";
import loadingBar from "../../components/PdkLoading.vue";

import $ from "jquery";

export default {
  store,
  components: { TourismRule, PdkBankLoading, loadingBar },
  data() {
    return {
      credit: 0,
      showModal: false,
      customerInfo: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        emailAddress: "",
        isCustomerReserver: true,
        gender: "",
        birthDate: "",
        nationalCode: "",
        flightNumber: "",
        classType: 1,
        customerRequest: "",
      },
      reservedData: {},
      deposit: 0,
      ipgList: [],
      selectedBank: 1,
      ruleChecked: false,
      selectedPaymentType: 1,
      paymentTypeItems: [],
      providerId: 0,
      providerName: "fasttrack",
      inBoundorderId: "",
      description: "",
      customerRequest: "",
      activeButton: true,
      isLoading: false,
      title: "",
      guestDetails: {},
      guestInfo: [],
      guestCount: 0,
      valueAmountChecked: false,
      customerValueAmount: 0,
      showBankPayment: true,
      showLoadingBar: false,
    };
  },
  computed: {
    GetSumDeposit() {
      this.deposit = this.$store.getters.GetSumDeposit;
      return this.$store.getters.GetSumDeposit;
    },
    GetCustomerValueAmount() {
      this.customerValueAmount =
        this.$store.getters.GetCustomerClubData.valueAmount;

      return this.customerValueAmount;
    },
    CalcPaidAmount() {
      let paidAmount = this.reservedData.totalAmount;
      if (
        parseInt(this.$store.getters.GetCustomerClubData.valueAmount) > 0 &&
        this.valueAmountChecked
      ) {
        paidAmount =
          parseInt(this.reservedData.totalAmount) -
          parseInt(this.customerValueAmount);
      }
      if (paidAmount <= 0) {
        paidAmount = 0;
        this.showBankPayment = false;
      } else this.showBankPayment = true;
      return parseInt(paidAmount);
    },
  },

  created() {
    this.credit = this.$store.getters.GetSelectedSourceDeposit;

    this.providerName = this.$route.params.providerName;
    if (this.providerName.toLowerCase() === "fasttrack") this.providerId = 2;
    else if (this.providerName.toLowerCase() === "dolphin") this.providerId = 1;

    if (this.providerId === 1) this.title = "پارک دلفین ها";
    else this.title = "فست ترک فرودگاه امام خمینی";

    this.checkStoreData();
    this.getAllIpg();

    if (parseInt(this.credit) < parseInt(this.reservedData.totalAmount)) {
      this.paymentTypeItems = [{ key: 1, value: "پرداخت آنلاین" }]; 
      this.selectedPaymentType = 1;
    } else {
      this.paymentTypeItems = [
        { key: 1, value: "پرداخت آنلاین" }, 
        { key: 3, value: "اعتباری" },
      ];
      this.selectedPaymentType = 3;
    } 
  
  },
  methods: {
    show() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    async getAllIpg() {
      if (this.providerId === 2) {
        this.getAllIpgFastTrack();
      } else {
        this.getAllIpgDolphin();
      }
    },
    async getAllIpgFastTrack() {
      this.$store.dispatch("getIPGs").then((res) => {
        this.ipgList = res.data;
        this.selectedBank = this.ipgList[0].bankId;
      });
    },
    async getAllIpgDolphin() {
      this.$store.dispatch("getIPGsDolphin").then((res) => {
        this.ipgList = res.data;
        this.selectedBank = this.ipgList[0].bankId;
      });
    },
    checkStoreData() {
      this.reservedData = this.$store.getters.GetSelectedReserve;
      this.customerInfo = this.$store.getters.GetCustomerInfo;
      this.guestCount = this.reservedData.guestCount;

      if (Object.keys(this.$store.getters.GetSelectedReserve).length == 0) {
        this.backToSearch();
      }

      this.guestDetails = this.$store.getters.GetGuestsInfo;
      const adultCount = this.guestDetails.adultCount;
      const childCount = this.guestDetails.childCount;
      const infantCount = this.guestDetails.infantCount;

      adultCount.forEach((element) => {
        this.guestInfo.push(element);
      });

      childCount.forEach((element) => {
        this.guestInfo.push(element);
      });

      infantCount.forEach((element) => {
        this.guestInfo.push(element);
      });
    },
    backToSearch() {
      this.$router
        .push({
          path: "/tourism/tourismSearch/" + this.providerName,
        })
        .catch(() => {});
    },
    editCustomerData() {
      this.$router.push({
        path: "/tourism/tourismBook/" + this.providerName,
      });
    },
    GeneratePaymentOrderId() {
      const random = Math.floor(100000 + Math.random() * 900000);
      let inBoundorderId = parseInt("66" + random);
      return inBoundorderId;
    },

    // async book() {
    //   if (parseInt(this.providerId) === 2) this.bookFastTrack();
    //   else this.bookDolphin();
    // },
    async book() {
      this.activeButton = false;

      const date = moment().add(-15, "years");

      const customer = {
        firstName: this.customerInfo.firstName,
        lastName: this.customerInfo.lastName,
        mobileNumber: this.customerInfo.mobileNumber,
        emailAddress: this.customerInfo.email,
        isCustomerReserver: true,
        genderId: this.customerInfo.gender,
        birthDate: date,
        nationalCode: this.customerInfo.nationalCode,
      };

      if (parseInt(this.providerId) === 2)
        this.description = this.customerInfo.flightNumber;

      // if (this.selectedPaymentType === 3) {
      //   //اعتباری فست ترک
      //   const reservedData = {
      //     addOnOptions: this.reservedData.addOnOptionList,
      //     productId: this.reservedData.productId,
      //     totalPrice: this.reservedData.totalPrice,
      //     arrivalDate: this.reservedData.fromDate,
      //     departureDate: this.reservedData.toDate,
      //     scheduleId: this.reservedData.scheduleId,
      //     sourceId: localStorage.getItem("SourceIdInReport"),
      //     sourceProfileId: localStorage.getItem("SourceProfileId"),
      //     customer: customer,
      //     source: {
      //       shName: localStorage.getItem("Username"),
      //       name: localStorage.getItem("Username"),
      //       email: localStorage.getItem("Email"),
      //       profileId: localStorage.getItem("SourceProfileId"),
      //       sourceId: localStorage.getItem("SourceIdInReport"),
      //       userId: 0,
      //     },
      //     guests: [
      //       { ageCategoryId: 3, count: this.reservedData.adultCount },
      //       { ageCategoryId: 2, count: this.reservedData.childCount },
      //       { ageCategoryId: 1, count: this.reservedData.infantCount },
      //     ],
      //     guestDetails: this.guestInfo,
      //     paymentType: this.selectedPaymentType,
      //     description: this.description,
      //     customerRequest: this.customerInfo.customerRequest,
      //     providerId: this.providerId,
      //   };
      //   const reservedResponse = await this.$store.dispatch(
      //     "depositBooking",
      //     reservedData
      //   );
      //   if (reservedResponse.data[0].errorCode === "0") {
      //     this.$router
      //       .push({
      //         path:
      //           "/tourism/printTicket/" +
      //           this.providerId +
      //           "/" +
      //           reservedResponse.data[0].refrenceId,
      //       })
      //       .catch(() => {});
      //     this.$store.dispatch(
      //       "getDepositInCrs",
      //       this.$store.getters.GetSourceIdInReport
      //     );
      //   } else {
      //     alert(reservedResponse.data[0].errorText);
      //     this.activeButton = true;
      //     this.isLoading = false;
      //   }
      // } else if (this.selectedPaymentType === 2) {
      //بانک

      const bookingData = {
        extensionData: "",
        paidAmount: parseInt(this.reservedData.totalAmount),
        paymentType: this.selectedPaymentType,
        payRequestId: "",
        saleOrderId: this.GeneratePaymentOrderId(),
        saleReferenceId: "",
        sourceId: localStorage.getItem("SourceIdInReport"),
        userId: 0,
        bankId: this.selectedBank,
      };
      const reservedData = {
        addOnOptions: this.reservedData.addOnOptionList,
        productId: this.reservedData.productId,
        totalPrice: this.reservedData.totalPrice,
        arrivalDate: this.reservedData.fromDate,
        departureDate: this.reservedData.toDate,
        scheduleId: this.reservedData.scheduleId,
        sourceId: localStorage.getItem("SourceIdInReport"),
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        userProfileId: localStorage.getItem("UserId"),
        customer: customer,
        source: {
          shName: localStorage.getItem("Username"),
          name: localStorage.getItem("Username"),
          email: localStorage.getItem("Email"),
          profileId: localStorage.getItem("SourceProfileId"),
          sourceId: localStorage.getItem("SourceIdInReport"),
          userId: 0,
        },
        guests: [
          { ageCategoryId: 3, count: this.reservedData.adultCount },
          { ageCategoryId: 2, count: this.reservedData.childCount },
          { ageCategoryId: 1, count: this.reservedData.infantCount },
        ],
        guestDetails: this.guestInfo,
        paymentType: this.selectedPaymentType,
        description: this.description,
        customerRequest: this.customerInfo.customerRequest,
        providerId: this.providerId,
        paymentModel: bookingData,
        successCallBackUrl: uri.tourismSuccessCallBackUrl + this.providerName,
        errorCallBackUrl: uri.tourismErrorCallBackUrl + this.providerName,
        customerClubValueAmountChecked: this.valueAmountChecked,
      };

      if (this.providerId === 2) {
        this.$store.dispatch("confirmBookingV2", reservedData).then((res) => {
     
   
          if (res.status == 200) {
            if (res.data.data[0].paymentType === 1) {
              this.isLoading = true;

              window.location.href =
                res.data.data[0].bankUrl + res.data.data[0].refrenceId;
            } else {
              this.$router.push({
                path:
                  "/tourism/printTicket/" +
                  this.providerName +
                  "/" + 
                  res.data.data[0].refrenceId,
              });
              //به روز رسانی اعتبار
              this.$store.dispatch(
                "getDepositInCrs",
                this.$store.getters.GetSourceIdInReport
              );
            }
            // if (this.customerValueAmount > 0) // دریافت مجدد اعتبار و امتیاز
            //   await this.$store.dispatch("getProfileByProfileId");
          } else {
            // alert("خطا در اتصال به بانک!!!");
            this.$toast.error("خطا در اتصال به بانک!!!", {
              position: "top-center",
              timeout: 4500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 1.59,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              icon: true,
              rtl: true,
            });
            this.activeButton = true;
            this.isLoading = false;
          }
        });
      } else if (this.providerId === 1) {
        this.showLoadingBar = true;
        this.$store
          .dispatch("confirmBookingV2Dolphin", reservedData)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.data[0].paymentType === 1) {
                this.isLoading = true;

                window.location.href =
                  res.data.data[0].bankUrl + res.data.data[0].refrenceId;
              } else {
                this.$router.push({
                  path:
                    "/tourism/printTicket/" +
                    this.providerName +
                    "/" +
                    res.data.data[0].refrenceId,
                });
                //به روز رسانی اعتبار
                this.$store.dispatch(
                  "getDepositInCrs",
                  this.$store.getters.GetSourceIdInReport
                );
              }
              // if (this.customerValueAmount > 0) // دریافت مجدد اعتبار و امتیاز
              //   await this.$store.dispatch("getProfileByProfileId");
            } else {
              this.$toast.error("خطا در اتصال به بانک!!!", {
                position: "top-center",
                timeout: 4500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 1.59,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                icon: true,
                rtl: true,
              });
              this.activeButton = true;
              this.isLoading = false;
              this.showLoadingBar = false;
            }
          });
      }
      // }
    },
    async bookDolphin() {
      this.activeButton = false;

      const date = moment().add(-15, "years");

      const customer = {
        firstName: this.customerInfo.firstName,
        lastName: this.customerInfo.lastName,
        mobileNumber: this.customerInfo.mobileNumber,
        emailAddress: this.customerInfo.email,
        isCustomerReserver: true,
        genderId: this.customerInfo.gender,
        birthDate: date,
        nationalCode: this.customerInfo.nationalCode,
      };

      if (this.selectedPaymentType === 3) {
        const reservedData = {
          addOnOptions: this.reservedData.addOnOptionList,
          productId: this.reservedData.productId,
          totalPrice: this.reservedData.totalPrice,
          arrivalDate: this.reservedData.fromDate,
          departureDate: this.reservedData.toDate,
          scheduleId: this.reservedData.scheduleId,
          sourceId: localStorage.getItem("SourceIdInReport"),
          sourceProfileId: localStorage.getItem("SourceProfileId"),
          customer: customer,
          source: {
            shName: localStorage.getItem("Username"),
            name: localStorage.getItem("Username"),
            email: localStorage.getItem("Email"),
            profileId: localStorage.getItem("SourceProfileId"),
            sourceId: localStorage.getItem("SourceIdInReport"),
            userId: 0,
          },
          guests: [
            { ageCategoryId: 3, count: this.reservedData.adultCount },
            { ageCategoryId: 2, count: this.reservedData.childCount },
            { ageCategoryId: 1, count: this.reservedData.infantCount },
          ],
          paymentType: 3,
          description: this.description,
          providerId: this.providerId,
        };
        const reservedResponse = await this.$store.dispatch(
          "depositBookingDolphin",
          reservedData
        );
        if (reservedResponse.data[0].errorCode === "0") {
          this.$router
            .push({
              path:
                "/tourism/printTicket/" +
                this.providerName +
                "/" +
                reservedResponse.data[0].refrenceId,
            })
            .catch(() => {});
          this.$store.dispatch(
            "getDepositInCrs",
            this.$store.getters.GetSourceIdInReport
          );
        } else {
          // alert(reservedResponse.data[0].errorText);
          this.$toast.error(reservedResponse.data[0], {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          this.activeButton = true;
          this.isLoading = false;
        }
      } else if (this.selectedPaymentType === 1) {
        this.isLoading = true;

        const bookingData = {
          extensionData: "",
          paidAmount: parseInt(this.reservedData.totalAmount),
          paymentType: this.selectedPaymentType,
          payRequestId: "",
          saleOrderId: this.GeneratePaymentOrderId(),
          saleReferenceId: "",
          sourceId: localStorage.getItem("SourceIdInReport"),
          userId: 0,
          bankId: this.selectedBank,
        };
        const reservedData = {
          addOnOptions: this.reservedData.addOnOptionList,
          productId: this.reservedData.productId,
          totalPrice: this.reservedData.totalPrice,
          arrivalDate: this.reservedData.fromDate,
          departureDate: this.reservedData.toDate,
          scheduleId: this.reservedData.scheduleId,
          sourceId: localStorage.getItem("SourceIdInReport"),
          sourceProfileId: localStorage.getItem("SourceProfileId"),
          customer: customer,
          source: {
            shName: localStorage.getItem("Username"),
            name: localStorage.getItem("Username"),
            email: localStorage.getItem("Email"),
            profileId: localStorage.getItem("SourceProfileId"),
            sourceId: localStorage.getItem("SourceIdInReport"),
            userId: 0,
          },
          guests: [
            { ageCategoryId: 3, count: this.reservedData.adultCount },
            { ageCategoryId: 2, count: this.reservedData.childCount },
            { ageCategoryId: 1, count: this.reservedData.infantCount },
          ],
          paymentType: 2,
          description: this.description,
          customerRequest: this.customerInfo.customerRequest,

          paymentModel: bookingData,
          successCallBackUrl: uri.tourismSuccessCallBackUrl + this.providerName,
          errorCallBackUrl: uri.tourismErrorCallBackUrl + this.providerName,
        };

        this.$store
          .dispatch("confirmBookingDolphin", reservedData)
          .then((res) => {
            if (res.status == 200)
              window.location.href =
                res.data.data[0].bankUrl + res.data.data[0].refrenceId;
            else {
              this.isLoading = false;
              // alert("خطا در اتصال به بانک!!!");
              this.$toast.error("خطا در اتصال به بانک!!!", {
                position: "top-center",
                timeout: 4500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 1.59,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                icon: true,
                rtl: true,
              });
            }
          });
      }
    },
  },
  mounted() {
    require("magnific-popup");
    $(this.$el.querySelector("#role_link")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
};
</script>

<style scoped>
.radio-margin {
  margin-left: 30px;
}
.form-check-label {
  padding: 5px 20px;
}
.form-check-label .img-size {
  width: 40px;
  border-radius: 0;
  box-shadow: none;
  border: 0;
  margin-left: 5px;
}
.form-check-input {
  margin-left: 10px;
  margin-top: 12px;
}

.radio-title {
  margin-left: 20px;
}

.radio-btn {
  display: block;
  position: relative;

  margin-bottom: 12px;
  cursor: pointer;
  font-size: 13px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-btn input {
  position: absolute;
  opacity: 1;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-sendanyway {
  padding: 0.1rem 1.25rem;
  margin-bottom: 0;
  background-color: #cbecfb !important;
    border-bottom: 1px solid rgb(154 223 255);
    color: #2561a4;
  margin-top: 20px !important;
  font-size: 16px;
  width: 100%;
  margin: 20px 70px 0px 70px;
  border-radius: 3px;
}

.pointer-bank {
  cursor: pointer;
}
</style>